import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_2 = { class: "text-2xl font-bold mb-2" }
const _hoisted_3 = { class: "text-sm text-gray-400 mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center mb-2"
}
const _hoisted_5 = {
  key: 1,
  class: "flex justify-center mb-2"
}
const _hoisted_6 = {
  key: 2,
  class: "flex justify-center mb-2"
}
const _hoisted_7 = {
  key: 3,
  class: "flex justify-center mb-2"
}
const _hoisted_8 = {
  key: 4,
  class: "flex justify-center mb-2"
}

import { computed } from 'vue';
import { Capacitor } from '@capacitor/core';
import { isPlatform, loadingController } from '@ionic/vue';
import { logoGoogle, logoFacebook, logoApple, callOutline, mailOutline } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';
import CustomButton from '@/shared/components/CustomButton.vue';
import useTenant from '@/shared/composables/useTenant';
import useAuth from '../composables/useAuth';
import { SocialProvider } from '@/shared/interfaces/user';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PreviousLoginModal',
  props: {
    previousLogin: {}
  },
  emits: ["continue-with-previous", "use-other", "onLoginSuccess"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig, tenantStyles } = getTenantConfigAndStyles();

const { oAuthLogin } = useAuth();
const login = async (provider: SocialProvider) => {
	if (tenantStyles.value) {
		const loading = await loadingController.create({
			message: t('general.please_wait'),
		});
		await loading.present();
		try {
			const user = await oAuthLogin(provider, tenantStyles.value);
			if (user.value.token) {
				emit('onLoginSuccess');
			}
			await loading.dismiss();
		} catch (e) {
			await loading.dismiss();
		}
	}
};

const withModalClose = async (callback: () => Promise<void> | void) => {
	emit('use-other');
	await callback();
};

const handleLoginWithPrevious = () => {
	withModalClose(() => {
		if (props.previousLogin) {
			if (props.previousLogin.provider === 'phone' || props.previousLogin.provider === 'email') {
				emit('continue-with-previous', props.previousLogin.provider);
			} else if (['google', 'facebook', 'apple'].includes(props.previousLogin.provider)) {
				login(props.previousLogin.provider as SocialProvider);
			}
		}
	});
};

const goTo = async (link: string) => {
	await router.push(link);
};

const methodLabel = computed(() => {
	switch (props.previousLogin?.provider) {
		case 'google':
			return 'Google';
		case 'facebook':
			return 'Facebook';
		case 'apple':
			return 'Apple';
		case 'phone':
			return 'Phone';
		case 'email':
			return 'Email';
		default:
			return '';
	}
});

return (_ctx: any,_cache: any) => {
  return (_ctx.previousLogin && _unref(tenantConfig) && _unref(tenantStyles))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('auth.previous_login_method.title')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('auth.previous_login_method.message', {
					method: methodLabel.value,
				})), 1),
        (_ctx.previousLogin.provider === 'phone')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(CustomButton, {
                class: "ion-no-margin",
                fill: "outline",
                color: "anykrowd-dark",
                onOnClick: _cache[0] || (_cache[0] = () => withModalClose(() => goTo('/auth/signinwithphone'))),
                text: "auth.continuePhone",
                iconLeft: _unref(callOutline)
              }, null, 8, ["iconLeft"])
            ]))
          : (_ctx.previousLogin.provider === 'email')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(CustomButton, {
                  class: "ion-no-margin",
                  fill: "outline",
                  color: "anykrowd-dark",
                  onOnClick: _cache[1] || (_cache[1] = () => withModalClose(() => goTo('/auth/signinhome?previousLogin=true'))),
                  text: "auth.continueEmail",
                  iconLeft: _unref(mailOutline)
                }, null, 8, ["iconLeft"])
              ]))
            : _createCommentVNode("", true),
        (_ctx.previousLogin.provider === 'apple' && _unref(Capacitor).isNativePlatform() && _unref(isPlatform)('ios'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(CustomButton, {
                class: "ion-no-margin",
                fill: "outline",
                color: "anykrowd-dark",
                onOnClick: handleLoginWithPrevious,
                text: "auth.continueApple",
                iconLeft: _unref(logoApple)
              }, null, 8, ["iconLeft"])
            ]))
          : (_ctx.previousLogin.provider === 'facebook')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(CustomButton, {
                  class: "ion-no-margin",
                  fill: "outline",
                  color: "anykrowd-dark",
                  onOnClick: handleLoginWithPrevious,
                  text: "auth.continueFacebook",
                  iconLeft: _unref(logoFacebook)
                }, null, 8, ["iconLeft"])
              ]))
            : (_ctx.previousLogin.provider === 'google')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(CustomButton, {
                    class: "ion-no-margin",
                    fill: "outline",
                    color: "anykrowd-dark",
                    onOnClick: handleLoginWithPrevious,
                    text: "auth.continueGoogle",
                    iconLeft: _unref(logoGoogle)
                  }, null, 8, ["iconLeft"])
                ]))
              : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "text-sm underline text-white mt-4",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('use-other')))
        }, [
          _createVNode(CustomButton, {
            class: "ion-no-margin",
            fill: "outline",
            color: "anykrowd-dark",
            onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('use-other'))),
            text: "auth.previous_login_method.use_another"
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})